import { mediaAssetService } from '@/components/shared/services/MediaAssetService';
import MimeTypeStoreFactory from '@/store/mime-type/MimeTypeStoreFactory';

const videoMimeTypeStore = MimeTypeStoreFactory.createModule(() => mediaAssetService.listVideoMimeTypes());

export { videoMimeTypeStore };
